/** Бренд (T10): каскад платформа → тенант → объект. */
export interface Brand {
  name: string;
  short: string;
  tagline: string;
  logo_data_url: string | null;
  accent: string | null;
  mail_from_name: string;
  requisites: string;
  powered_by: string;
}

/** Переопределение объекта: только заданные поля. */
export interface BrandOverride {
  name?: string | null;
  short?: string | null;
  tagline?: string | null;
  logo_data_url?: string | null;
  mail_from_name?: string | null;
  requisites?: string | null;
}

export const DEFAULT_BRAND: Brand = {
  name: "РУСЬ ИИ",
  short: "РИ",
  tagline: "агентные закупки",
  logo_data_url: null,
  accent: null,
  mail_from_name: "",
  requisites: "",
  powered_by: "",
};
